const routeStyles = [
    {
        backgroundColor : "rgb(223, 222, 11)",
        color           : "rgb(0, 0, 0)"
    },
    {
        backgroundColor : "#ffa500",
        color           : "rgb(0, 0, 0)"
    },
    {
        backgroundColor : "#196AE5",
        color           : "rgb(255, 255, 255)"
    },
    {
        backgroundColor : "#4B0D73",
        color           : "rgb(255, 255, 255)"
    },
    {
        backgroundColor : "#3DC213",
        color           : "rgb(255, 255, 255)"
    },
    {
        backgroundColor : "rgb(236, 0, 140)",
        color           : "rgb(255, 255, 255)"
    },
    {
        backgroundColor : "rgb(215, 178, 98)",
        color           : "rgb(255, 255, 255)"
    },
    {
        backgroundColor : "rgb(203, 104, 62)",
        color           : "rgb(0, 0, 0)"
    },
    {
        backgroundColor : "rgb(14, 167, 164)",
        color           : "rgb(255, 255, 255)"
    },
    {
        backgroundColor : "rgb(23, 116, 64)",
        color           : "rgb(255, 255, 255)"
    },
    {
        backgroundColor : "rgb(169, 48, 148)",
        color           : "rgb(255, 255, 255)"
    },
    {
        backgroundColor : "rgb(42, 101, 154)",
        color           : "rgb(255, 255, 255)"
    },
    {
        backgroundColor : "rgb(170, 33, 34)",
        color           : "rgb(255, 255, 255)"
    },
    {
        backgroundColor : "rgb(188, 137, 187)",
        color           : "rgb(255, 255, 255)"
    },
    {
        backgroundColor : "rgb(15, 114, 171)",
        color           : "rgb(255, 255, 255)"
    },
    {
        backgroundColor : "rgb(155, 185, 141)",
        color           : "rgb(255, 255, 255)"
    },
    {
        backgroundColor : "rgb(166, 33, 40)",
        color           : "rgb(255, 255, 255)"
    },
    {
        backgroundColor : "rgb(228, 179, 48)",
        color           : "rgb(0, 0, 0)"
    },
    {
        backgroundColor : "rgb(96, 42, 139)",
        color           : "rgb(255, 255, 255)"
    },
    {
        backgroundColor : "rgb(109, 119, 91)",
        color           : "rgb(255, 255, 255)"
    },
    {
        backgroundColor : "rgb(21, 171, 236)",
        color           : "rgb(255, 255, 255)"
    },
    {
        backgroundColor : "rgb(138, 94, 63)",
        color           : "rgb(255, 255, 255)"
    },
    {
        backgroundColor : "rgb(36, 99, 138)",
        color           : "rgb(255, 255, 255)"
    },
    {
        backgroundColor : "rgb(221, 215, 29)",
        color           : "rgb(255, 255, 255)"
    },
    {
        backgroundColor : "rgb(219, 93, 51)",
        color           : "rgb(255, 255, 255)"
    },
    {
        backgroundColor : "rgb(0, 66, 122)",
        color           : "rgb(255, 255, 255)"
    },
    {
        backgroundColor : "rgb(237, 28, 36)",
        color           : "rgb(255, 255, 255)"
    },
    {
        backgroundColor : "rgb(8, 169, 46)",
        color           : "rgb(0, 0, 0)"
    },
    {
        backgroundColor : "rgb(194, 173, 171)",
        color           : "rgb(0, 0, 15)"
    },
    {
        backgroundColor : "rgb(18, 168, 157)",
        color           : "rgb(255, 255, 255)"
    },
    {
        backgroundColor : "rgb(180, 75, 194)",
        color           : "rgb(255, 255, 255)"
    }
] as {
    backgroundColor : string;
    color           : string;
    backgroundHex?  : {
        r : number;
        g : number;
        b : number;
    };
}[];

export default routeStyles;